// import Vue from 'vue'
// import axios from 'axios'
import router from '../router'
import store from "../store"
import { Message } from 'element-ui';
import VueCookies from 'vue-cookies';
// Vue.prototype.$http = axios
import baseURL from './baseUrl';

if(baseURL) axios.defaults.baseURL=baseURL
axios.defaults.timeout = 20000;
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

//在main.js设置全局的请求次数，请求的间隙
axios.defaults.retry = 1;
axios.defaults.retryDelay = 1000;

//http request 封装请求头拦截器
axios.interceptors.request.use(config => {
  if(config.params){
    config.params.devive_client=1
  }
  return config;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  if (response.data) {
    if (response.data.code == 403 || response.data.msg == '身份令牌过期' || response.data.message == '身份令牌过期') {//特殊处理：重新登录
      Message.error(response.data.msg || response.data.message)
      VueCookies.set('uid', '')
      VueCookies.set('supplier_id', '')
      VueCookies.set('wallet_amount', '')
      VueCookies.set('browser_token', '')
      var merchantStatus = store.state.userOrMerchant.merchantStatus
      store.commit("userOrder/changeCartNum", 0);
      store.dispatch('userOrMerchant/userStatusAction', false)
      store.dispatch('userOrMerchant/merchantStatusAction', false)
      if (merchantStatus) {
        router.replace("/BusinessUser")
      } else {
        router.replace("/UserLogin")
      }
      return Promise.reject(response.data.msg || response.data.message)
    }
    if (response.data.code != undefined) {
      if (response.data.code == 0 || response.data.code == 1) {
        return response
      } else if (response.data.code == 402) {//特殊处理：设置支付密码
        return response
      } else if (response.data.code == 409) {//需要刷新列表
        Message.error(response.data.msg || response.data.message)
        return {
          data: {
            code: '409', data: response.data.data
          }
        }
      } else {
        Message.error(response.data.msg || response.data.message)
        return {
          data: {
            code: 'error', data: response.data.data, msg: response.data.msg || response.data.message
          }
        }
      }
    } else {
      return response
    }
  } else {
    Message.error("接口没有返回值")
    return Promise.reject("接口没有返回值")
  }
}, function axiosRetryInterceptor(err) {
  var config = err.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return axios(config);
  });
});

export default axios;


// WEBPACK FOOTER //
// ./src/api/api.js